import { useState, useEffect } from "react";
import { getCookie } from "../utils/cookieUtils";

function useBatchInfoGet() {
    const username = getCookie("X-Spl-Username-Header");
    const [batchNames, setBatchNames] = useState([]);
    const [batchIds, setBatchIds] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/percept_db/v1/audio?type=batch-info`, {
      method: 'GET',
      headers: {
        'X-Spl-Username-Header': username,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const batchNames = data.data.batch_info.map((batch) => batch.batch_name);
        setBatchNames(batchNames);
        console.log()
        const batchIds = data.data.batch_info.map((batch) => batch.batch_id);
        setBatchIds(batchIds);
      })
      .catch((error) => console.log("Excepted!"));
  }, []);

  return { batchNames, batchIds };
}

export default useBatchInfoGet;
